export default "__VITE_ASSET__BwG9Gwzu__"